module.exports = () => {
    const docBody = $(document.body);
    const staticMenuColClassName = 'col-12 col-lg-3';
    const staticMainWrapperNav = $('.static-main-wrapper .account-nav');

    if (staticMainWrapperNav.length) {
        staticMainWrapperNav.parents('.content-asset').addClass(staticMenuColClassName);
    }

    $('.static-content-wrapper').addClass('active');

    docBody.on('click', '.faq-question-heading', (e) => {
        const thisTarget = $(e.currentTarget);
        const currentArrow = thisTarget.find('.icon-down-arrow-line');
        const currentResponse = thisTarget.siblings('.faq-question-description');

        const allArrows = $('.faq-question-heading .icon-down-arrow-line').not(currentArrow);
        const allResponses = $('.faq-question-description').not(currentResponse);

        allArrows.removeClass('open');
        allResponses.slideUp();

        currentArrow.toggleClass('open');
        thisTarget.siblings('.faq-question-description').slideToggle();
    });

    const carouselBannerItems = $('.experience-component .carousel-module .item');
    if (carouselBannerItems.length) {
        carouselBannerItems.each((_i, element) => {
            const thisTarget = $(element);
            let textClass = thisTarget.find('.text-block').length ? thisTarget.find('.text-block').attr('class') : null;
            if (textClass) {
                textClass = textClass.replace('text-box ', '');
                thisTarget.addClass(textClass);
            }
        });
    }

    const tableElements = $('.asset-container table');
    if (tableElements.length) {
        tableElements.each((_i, element) => {
            const table = $(element);
            table.addClass('table').parents('.asset-container').addClass('table-overflow');
        });
    }

    const gridContainers = $('[class^="mobile-"]');
    if (gridContainers.length) {
        gridContainers.each((_i, element) => {
            const thisTarget = $(element);
            const childPaddingSize = thisTarget.find('.banner').css('padding-right');
            const bannersContainerMaxWidth = thisTarget.find('.container-layout').css('max-width');
            thisTarget.find('.container-layout').css('max-width', `calc((${childPaddingSize} * 2) + ${bannersContainerMaxWidth})`);
        });
    }

    const staticPageFirsComponent = $('.static-main-wrapper .storepage .experience-component').first();
    if (staticPageFirsComponent.length && (staticPageFirsComponent.hasClass('experience-assets-banner') || staticPageFirsComponent.hasClass('experience-commerce_layouts-carouselBanner'))) {
        $(document.body).addClass('header-transparency');
        staticPageFirsComponent.find('> div').addClass('disable-transition');
    }

};
